module.exports = __webpack_public_path__ + "img/agents.d4d390c4.svg";